const adZoneClassNames = ['ad-zone-one', 'ad-zone-two']

export default {
  props: ['adHeights'],
  data: function () {
    return {
      allParagraphs: null,
      textParagraphs: [],
      landmarkParagraphs: {
        second: null,
        fifth: null
      }
    }
  },
  mounted: function () {
    this.observeWrapperHeight()
  },
  computed: {
    setAdHeights: function () {
      return [
        `${this.adHeights?.[0]}px` || '0',
        `${this.adHeights?.[1]}px` || '0'
      ]
    },
    adZoneStyles: function () {
      return {
        '--ad-one-height': this.setAdHeights[0] ? this.setAdHeights[0] : '0',
        '--ad-two-height': this.setAdHeights[1] ? this.setAdHeights[1] : '0'
      }
    }
  },
  methods: {
    createAdZones: function () {
      this.resetVars()
      this.getAllParagraphs()
      this.parseParagraphs()
      this.getLandmarkParagraphs()
      this.createAdPositions()
      this.setLandmarkParagraphs()
    },
    getAllParagraphs: function () {
      const selectedHTML = this.$refs.displayBody
      if (!selectedHTML) {
        return
      }
      this.allParagraphs = selectedHTML.getElementsByTagName('P')
    },
    parseParagraphs: function () {
      this.allParagraphs && this.allParagraphs.forEach(p => {
        this.resetAdZones(p)
        if (this.paragraphFilter(p)) {
          this.textParagraphs.push(p)
        }
      })
    },
    getLandmarkParagraphs: function () {
      this.landmarkParagraphs.second = this.textParagraphs.length >= 2 ? this.textParagraphs[1] : null
      this.landmarkParagraphs.fifth = this.textParagraphs.length >= 5 ? this.textParagraphs[4] : null
    },
    setLandmarkParagraphs: function () {
      this.landmarkParagraphs.second && this.landmarkParagraphs.second.classList.add(adZoneClassNames[0])
      this.landmarkParagraphs.fifth && this.landmarkParagraphs.fifth.classList.add(adZoneClassNames[1])
    },
    resetAdZones: function (p) {
      adZoneClassNames.forEach(className => p.classList.remove(className))
    },
    resetVars: function () {
      this.landmarkParagraphs = { second: null, fifth: null }
      this.allParagraphs = null
      this.textParagraphs = []
    },
    paragraphFilter: function (p) {
      const filter = {
        words: p.innerHTML.split(' '),
        tagRegex: new RegExp('(<[^>]*>)'),
        get hasHtmlTag () {
          return this.tagRegex.test(this.words[0])
        },
        hasClassName: p.className !== '',
        hasContent: p.innerHTML !== '',
        hasList: p.parentElement.nodeName === 'LI'
      }

      return !filter.hasClassName && filter.hasContent & filter.words.length > 10 && !filter.hasHtmlTag && !filter.hasList
    },
    createAdPositions: function () {
      const adPositionOne = {
        offsetTop: this.landmarkParagraphs?.second?.offsetTop,
        offsetHeight: this.landmarkParagraphs?.second?.offsetHeight
      }
      const adPositionTwo = {
        offsetTop: this.landmarkParagraphs?.fifth?.offsetTop,
        offsetHeight: this.landmarkParagraphs?.fifth?.offsetHeight
      }

      const params = []
      params[0] = this.landmarkParagraphs.second ? adPositionOne : false
      params[1] = this.landmarkParagraphs.fifth ? adPositionTwo : false

      this.$emit('adZonePositions', params[0], params[1])
    },
    observeWrapperHeight: function () {
      const resizeObserver = new ResizeObserver(() => {
        this.createAdZones()
      })
      resizeObserver.observe(this.$refs.wrapper)
    }
  }
}
